import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftArrowIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17 9L1.99999 9",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.99999 16L0.999992 9L7.99999 2",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgLeftArrowIcon;
